import { recipientsViewEnabled } from '@permissions/recipients.permissions'

const RECIPIENTS = ({
  permissionIsEnabled,
  componentIsEnabled,
  routeName,
  businessModel
}) => {
  return {
    key: 'recipients',
    routeName: 'recipients',
    label: 'sidemenu.recipients',
    showSection: recipientsViewEnabled(
      permissionIsEnabled,
      componentIsEnabled,
      businessModel
    ),
    active:
      routeName === 'recipients' ||
      routeName === 'recipientsCreate' ||
      routeName === 'recipientsDetail',
    new: false
  }
}

export default RECIPIENTS
